import { Check, MapPin, Plug } from "lucide-react";
import { SectionReveal, ChapterHeading } from "./Shared";
import { useLang } from "../../i18n";

const YOU_ICONS = [MapPin, Plug];

export default function Comparison() {
  const { t } = useLang();
  const c = t.comparison;
  return (
    <section id="nasil" className="mx-auto max-w-7xl px-5 py-28 sm:px-8" data-testid="comparison-section">
      <ChapterHeading
        index="05"
        label={c.label}
        title={c.title}
        sub={c.sub}
      />

      <div className="mt-16 grid gap-5 lg:grid-cols-2">
        <SectionReveal delay={0.1}>
          <div className="h-full rounded-2xl border border-[#9B7AE8]/30 bg-[linear-gradient(160deg,rgba(201,176,255,0.5),rgba(155,122,232,0.12))] p-8 shadow-[0_18px_50px_rgba(155,122,232,0.15)] sm:p-10" data-testid="comparison-we-provide">
            <span className="font-nav rounded-full border border-[#9B7AE8]/40 bg-white/50 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.25em] text-[#7B5FD0]">
              {c.weBadge}
            </span>
            <h3 className="font-display mt-6 text-2xl font-bold text-[#221A3D]">{c.weTitle}</h3>
            <ul className="mt-8 space-y-4">
              {c.we.map((item, i) => (
                <li key={i} data-testid={`we-provide-item-${i}`} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#9B7AE8] text-white">
                    <Check size={13} strokeWidth={3} />
                  </span>
                  <span className="text-base text-[#3A2E63]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.2}>
          <div className="h-full rounded-2xl border border-[#9B7AE8]/20 bg-white p-8 shadow-[0_18px_50px_rgba(155,122,232,0.1)] sm:p-10" data-testid="comparison-you-provide">
            <span className="font-nav rounded-full border border-[#9B7AE8]/30 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.25em] text-[#6B6386]">
              {c.youBadge}
            </span>
            <h3 className="font-display mt-6 text-2xl font-bold text-[#221A3D]">{c.youTitle}</h3>
            <ul className="mt-8 space-y-4">
              {c.you.map((text, i) => {
                const Icon = YOU_ICONS[i];
                return (
                  <li key={i} data-testid={`you-provide-item-${i}`} className="flex items-start gap-4">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#9B7AE8]/40 text-[#9B7AE8]">
                      <Icon size={13} strokeWidth={2.5} />
                    </span>
                    <span className="text-base text-[#5F5780]">{text}</span>
                  </li>
                );
              })}
            </ul>
            <p className="font-nav mt-10 border-t border-[#9B7AE8]/15 pt-6 text-[11px] font-medium uppercase tracking-[0.25em] text-[#8E85AC]">
              {c.note}
            </p>
          </div>
        </SectionReveal>
      </div>
    </section>
  );
}
